import { useEffect, useState } from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import { CheckBox } from '../form-elements/checkbox.component';
import { InputBox } from '../form-elements/inputbox.component';
import { DropdownMenu } from '../form-elements/dropdownmenu.component';
import { additionalIncomeSources, usStates } from './values';
import { InputBoxMoney } from '../form-elements/inputbox-money.component';
import { InputBoxNumber } from '../form-elements/inputbox-number.component';
import { InputBoxPhone } from '../form-elements/inputbox-phone.component';

interface CoapplicantEmploymentInformationFormProps {
  values?: any;
  errors?: any;
  touched?: any;
  handleChange?: any;
  handleBlur?: any;
  setFieldValue?: any;
}

export const initialValuesCoapplicantEmploymentInformation = {
  // step #4
  coapplicantIsRetired: false,
  coapplicantRetirementIncome: '',
  coapplicantRetirementYears: '',
  coapplicantRetirementMonths: '',

  coapplicantIsEmployed: false,
  coapplicantEmployerName: '',
  coapplicantOccupationTitle: '',
  coapplicantGrossMonthlyIncome: '',
  coapplicantEmployerAddressLine1: '',
  coapplicantEmployerCity: '',
  coapplicantEmployerState: '',
  coapplicantEmployerZipCode: '',
  coapplicantEmployerPhoneNumber: '',
  coapplicantEmployedYears: '',
  coapplicantEmployedMonths: '',
  coapplicantPreviousEmployerName: '',
  // coapplicantPreviousEmployerPhoneNumber: "",
  coapplicantPreviousOccupationTitle: '',
  coapplicantPreviousGrossMonthlyIncome: '',
  // coapplicantPreviousEmployerAddressLine1: "",
  // coapplicantPreviousEmployerCity: "",
  // coapplicantPreviousEmployerState: "",
  // coapplicantPreviousEmployerZipCode: "",
  coapplicantPreviousEmployedYears: '',
  coapplicantPreviousEmployedMonths: '',

  coapplicantIsAdditionalIncome: false,
  coapplicantAdditionalIncomeSource: '',
  coapplicantAdditionalIncomeSourceOther: '',
  coapplicantAdditionalMonthlyIncome: '',
};

export const CoapplicantEmploymentInformationForm: React.FC<CoapplicantEmploymentInformationFormProps> = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
}) => {
  const [shouldShowPreviousEmployment, setShouldShowPreviousEmployment] = useState(false);

  useEffect(() => {
    if (values.haveCoApplicant === false) {
      setFieldValue('coapplicantIsRetired', initialValuesCoapplicantEmploymentInformation.coapplicantIsRetired);
      setFieldValue(
        'coapplicantRetirementIncome',
        initialValuesCoapplicantEmploymentInformation.coapplicantRetirementIncome
      );
      setFieldValue(
        'coapplicantRetirementYears',
        initialValuesCoapplicantEmploymentInformation.coapplicantRetirementYears
      );
      setFieldValue(
        'coapplicantRetirementMonths',
        initialValuesCoapplicantEmploymentInformation.coapplicantRetirementMonths
      );

      setFieldValue('coapplicantEmployerName', initialValuesCoapplicantEmploymentInformation.coapplicantEmployerName);
      setFieldValue(
        'coapplicantOccupationTitle',
        initialValuesCoapplicantEmploymentInformation.coapplicantOccupationTitle
      );
      setFieldValue(
        'coapplicantGrossMonthlyIncome',
        initialValuesCoapplicantEmploymentInformation.coapplicantGrossMonthlyIncome
      );
      setFieldValue(
        'coapplicantEmployerAddressLine1',
        initialValuesCoapplicantEmploymentInformation.coapplicantEmployerAddressLine1
      );
      setFieldValue('coapplicantEmployerCity', initialValuesCoapplicantEmploymentInformation.coapplicantEmployerCity);
      setFieldValue('coapplicantEmployerState', initialValuesCoapplicantEmploymentInformation.coapplicantEmployerState);
      setFieldValue(
        'coapplicantEmployerZipCode',
        initialValuesCoapplicantEmploymentInformation.coapplicantEmployerZipCode
      );
      setFieldValue(
        'coapplicantEmployerPhoneNumber',
        initialValuesCoapplicantEmploymentInformation.coapplicantEmployerPhoneNumber
      );
      setFieldValue('coapplicantEmployedYears', initialValuesCoapplicantEmploymentInformation.coapplicantEmployedYears);
      setFieldValue(
        'coapplicantEmployedMonths',
        initialValuesCoapplicantEmploymentInformation.coapplicantEmployedMonths
      );
      setFieldValue(
        'coapplicantPreviousEmployerName',
        initialValuesCoapplicantEmploymentInformation.coapplicantPreviousEmployerName
      );
      setFieldValue(
        'coapplicantPreviousOccupationTitle',
        initialValuesCoapplicantEmploymentInformation.coapplicantPreviousOccupationTitle
      );
      setFieldValue(
        'coapplicantPreviousGrossMonthlyIncome',
        initialValuesCoapplicantEmploymentInformation.coapplicantPreviousGrossMonthlyIncome
      );
      setFieldValue(
        'coapplicantPreviousEmployedYears',
        initialValuesCoapplicantEmploymentInformation.coapplicantPreviousEmployedYears
      );
      setFieldValue(
        'coapplicantPreviousEmployedMonths',
        initialValuesCoapplicantEmploymentInformation.coapplicantPreviousEmployedMonths
      );

      setFieldValue(
        'coapplicantAdditionalIncomeSource',
        initialValuesCoapplicantEmploymentInformation.coapplicantAdditionalIncomeSource
      );
      setFieldValue(
        'coapplicantAdditionalIncomeSourceOther',
        initialValuesCoapplicantEmploymentInformation.coapplicantAdditionalIncomeSourceOther
      );
      setFieldValue(
        'coapplicantAdditionalMonthlyIncome',
        initialValuesCoapplicantEmploymentInformation.coapplicantAdditionalMonthlyIncome
      );
    }
  }, [setFieldValue, values.haveCoApplicant]);

  useEffect(() => {
    if (values.coapplicantIsRetired === false) {
      setFieldValue(
        'coapplicantRetirementIncome',
        initialValuesCoapplicantEmploymentInformation.coapplicantRetirementIncome
      );
      setFieldValue(
        'coapplicantRetirementYears',
        initialValuesCoapplicantEmploymentInformation.coapplicantRetirementYears
      );
      setFieldValue(
        'coapplicantRetirementMonths',
        initialValuesCoapplicantEmploymentInformation.coapplicantRetirementMonths
      );
    }
  }, [setFieldValue, values.coapplicantIsRetired]);

  useEffect(() => {
    // if retired and no retirement years or months, skip
    if (
      values.coapplicantIsRetired === true &&
      !(values.coapplicantRetirementYears || values.coapplicantRetirementMonths)
    ) {
      return;
    }
    // if employed and no employed years or months, skip
    if (
      values.coapplicantIsEmployed === true &&
      !(values.coapplicantEmployedYears || values.coapplicantEmployedMonths)
    ) {
      return;
    }
    // tricky requirements:
    // Previous Employment fields requirements:

    // SHOW PREVIOUS EMPLOYMENT
    // Retired less than 2 years AND not employed
    // Retired less than 2 years AND employed (LESS THAN 2 YEARS)
    // Employed less than 2 years AND not retired
    // Employed less than 2 years AND retired (LESS THAN 2 YEARS)

    // HIDE PREVIOUS EMPLOYMENT
    // Retired greater than 2 years AND not employed
    // Retired greater than 2 years AND employed greater than 2 years
    // Retired less than 2 years AND employed greater than 2 years
    // Employed greater than 2 years AND not retired
    // Employed greater than 2 years AND retired greater than 2 years
    // Employed less than 2 years AND retired greater than 2 years

    const _isRetiredLessThanTwoYears =
      values.coapplicantIsRetired &&
      (values.coapplicantRetirementYears || values.coapplicantRetirementMonths) &&
      Number(values.coapplicantRetirementYears) * 12 + Number(values.coapplicantRetirementMonths) < 24;

    const _isRetiredGreaterThanTwoYears =
      values.coapplicantIsRetired &&
      (values.coapplicantRetirementYears || values.coapplicantRetirementMonths) &&
      Number(values.coapplicantRetirementYears) * 12 + Number(values.coapplicantRetirementMonths) >= 24;

    const _isEmployedLessThanTwoYears =
      values.coapplicantIsEmployed &&
      (values.coapplicantEmployedYears || values.coapplicantEmployedMonths) &&
      Number(values.coapplicantEmployedYears) * 12 + Number(values.coapplicantEmployedMonths) < 24;

    const _isEmployedGreaterThanTwoYears =
      values.coapplicantIsEmployed &&
      (values.coapplicantEmployedYears || values.coapplicantEmployedMonths) &&
      Number(values.coapplicantEmployedYears) * 12 + Number(values.coapplicantEmployedMonths) >= 24;

    // Show previous employment ONLY if these conditions are met
    const _shouldShowPreviousEmployment =
      // Show cases
      ((_isRetiredLessThanTwoYears && !values.coapplicantIsEmployed) || // Retired < 2 years AND not employed
        (_isRetiredLessThanTwoYears && _isEmployedLessThanTwoYears) || // Retired < 2 years AND employed < 2 years
        (_isEmployedLessThanTwoYears && !values.coapplicantIsRetired) || // Employed < 2 years AND not retired
        (_isEmployedLessThanTwoYears && _isRetiredLessThanTwoYears)) && // Employed < 2 years AND retired < 2 years
      // AND none of the hide cases are true
      !(_isRetiredGreaterThanTwoYears || _isEmployedGreaterThanTwoYears); // Hide if either is > 2 years

    if (!_shouldShowPreviousEmployment) {
      // Reset previous employment fields if not needed
      setFieldValue(
        'coapplicantPreviousEmployerName',
        initialValuesCoapplicantEmploymentInformation.coapplicantPreviousEmployerName
      );
      // setFieldValue(
      //   "coapplicantPreviousEmployerPhoneNumber",
      //   initialValuesCoapplicantEmploymentInformation.coapplicantPreviousEmployerPhoneNumber
      // );
      setFieldValue(
        'coapplicantPreviousOccupationTitle',
        initialValuesCoapplicantEmploymentInformation.coapplicantPreviousOccupationTitle
      );
      setFieldValue(
        'coapplicantPreviousGrossMonthlyIncome',
        initialValuesCoapplicantEmploymentInformation.coapplicantPreviousGrossMonthlyIncome
      );
      setFieldValue(
        'coapplicantPreviousEmployedYears',
        initialValuesCoapplicantEmploymentInformation.coapplicantPreviousEmployedYears
      );
      setFieldValue(
        'coapplicantPreviousEmployedMonths',
        initialValuesCoapplicantEmploymentInformation.coapplicantPreviousEmployedMonths
      );
    }

    setShouldShowPreviousEmployment(_shouldShowPreviousEmployment);
  }, [
    setFieldValue,
    values.coapplicantRetirementYears,
    values.coapplicantRetirementMonths,
    values.coapplicantEmployedYears,
    values.coapplicantEmployedMonths,
    values.coapplicantIsEmployed,
    values.coapplicantIsRetired,
  ]);

  // if additional income is not selected, set the initial values
  useEffect(() => {
    if (values.coapplicantIsAdditionalIncome === false) {
      setFieldValue(
        'coapplicantAdditionalIncomeSource',
        initialValuesCoapplicantEmploymentInformation.coapplicantAdditionalIncomeSource
      );
      setFieldValue(
        'coapplicantAdditionalIncomeSourceOther',
        initialValuesCoapplicantEmploymentInformation.coapplicantAdditionalIncomeSourceOther
      );
      setFieldValue(
        'coapplicantAdditionalMonthlyIncome',
        initialValuesCoapplicantEmploymentInformation.coapplicantAdditionalMonthlyIncome
      );
    }
  }, [setFieldValue, values.coapplicantIsAdditionalIncome]);

  // if additional income source is not other, set the other field to be required
  useEffect(() => {
    if (values.coapplicantAdditionalIncomeSource?.toLowerCase() !== 'other') {
      setFieldValue(
        'coapplicantAdditionalIncomeSourceOther',
        initialValuesCoapplicantEmploymentInformation.coapplicantAdditionalIncomeSourceOther
      );
    }
  }, [setFieldValue, values.coapplicantAdditionalIncomeSource]);

  return (
    <>
      {values.haveCoApplicant === true ? (
        <div id="coapplicant-info">
          <Row>
            <Col xs={12}>
              <h3>Co-Buyer Employment Information</h3>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <CheckBox
                label="Click here if Retired or Disabled."
                name="coapplicantIsRetired"
                //  value={true}
                valueForm={values.coapplicantIsRetired}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.coapplicantIsRetired && !errors.coapplicantIsRetired}
                isInvalid={touched.coapplicantIsRetired && errors.coapplicantIsRetired}
                errorFeedback={errors.coapplicantIsRetired}
              />
            </Col>
          </Row>

          {values.coapplicantIsRetired ? (
            <>
              <Row>
                <Col xs={12} md={6} lg={4}>
                  <InputBoxMoney
                    label="Retirement Income:"
                    name="coapplicantRetirementIncome"
                    value={values.coapplicantRetirementIncome}
                    onChange={handleChange}
                    setFieldValue={setFieldValue}
                    onBlur={handleBlur}
                    isValid={touched.coapplicantRetirementIncome && !errors.coapplicantRetirementIncome}
                    isInvalid={touched.coapplicantRetirementIncome && errors.coapplicantRetirementIncome}
                    errorFeedback={errors.coapplicantRetirementIncome}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <Form.Label>How Long have you been retired? </Form.Label>
                </Col>
              </Row>
              <Row>
                <Col xs={6} md={4}>
                  <InputBoxNumber
                    label="Years:"
                    name="coapplicantRetirementYears"
                    value={values.coapplicantRetirementYears}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    isValid={touched.coapplicantRetirementYears && !errors.coapplicantRetirementYears}
                    isInvalid={touched.coapplicantRetirementYears && errors.coapplicantRetirementYears}
                    errorFeedback={errors.coapplicantRetirementYears}
                  />
                </Col>
                <Col xs={6} md={4}>
                  <InputBoxNumber
                    label="Months:"
                    name="coapplicantRetirementMonths"
                    value={values.coapplicantRetirementMonths}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    isValid={touched.coapplicantRetirementMonths && !errors.coapplicantRetirementMonths}
                    isInvalid={touched.coapplicantRetirementMonths && errors.coapplicantRetirementMonths}
                    errorFeedback={errors.coapplicantRetirementMonths}
                  />
                </Col>
              </Row>
            </>
          ) : null}

          <Row>
            <Col xs={12}>
              <CheckBox
                label="Click here if Currently Employed"
                name="coapplicantIsEmployed"
                // value={true}
                valueForm={values.coapplicantIsEmployed}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.coapplicantIsEmployed && !errors.coapplicantIsEmployed}
                isInvalid={touched.coapplicantIsEmployed && errors.coapplicantIsEmployed}
                errorFeedback={errors.coapplicantIsEmployed}
              />
            </Col>
          </Row>

          {values.coapplicantIsEmployed ? (
            <>
              <Row>
                <Col xs={12}>
                  <InputBox
                    label="Employer Business Name"
                    name="coapplicantEmployerName"
                    value={values.coapplicantEmployerName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.coapplicantEmployerName && !errors.coapplicantEmployerName}
                    isInvalid={touched.coapplicantEmployerName && errors.coapplicantEmployerName}
                    errorFeedback={errors.coapplicantEmployerName}
                    length={100}
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <InputBox
                    label="Occupation Title"
                    name="coapplicantOccupationTitle"
                    value={values.coapplicantOccupationTitle}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.coapplicantOccupationTitle && !errors.coapplicantOccupationTitle}
                    isInvalid={touched.coapplicantOccupationTitle && errors.coapplicantOccupationTitle}
                    errorFeedback={errors.coapplicantOccupationTitle}
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <InputBoxMoney
                    label="Gross Monthly Income:"
                    name="coapplicantGrossMonthlyIncome"
                    value={values.coapplicantGrossMonthlyIncome}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    isValid={touched.coapplicantGrossMonthlyIncome && !errors.coapplicantGrossMonthlyIncome}
                    isInvalid={touched.coapplicantGrossMonthlyIncome && errors.coapplicantGrossMonthlyIncome}
                    errorFeedback={errors.coapplicantGrossMonthlyIncome}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                  <InputBox
                    label="Employer Address"
                    name="coapplicantEmployerAddressLine1"
                    value={values.coapplicantEmployerAddressLine1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.coapplicantEmployerAddressLine1 && !errors.coapplicantEmployerAddressLine1}
                    isInvalid={touched.coapplicantEmployerAddressLine1 && errors.coapplicantEmployerAddressLine1}
                    errorFeedback={errors.coapplicantEmployerAddressLine1}
                    length={100}
                  />
                </Col>
                <Col xs={12} lg={4}>
                  <InputBox
                    label="City"
                    name="coapplicantEmployerCity"
                    value={values.coapplicantEmployerCity}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.coapplicantEmployerCity && !errors.coapplicantEmployerCity}
                    isInvalid={touched.coapplicantEmployerCity && errors.coapplicantEmployerCity}
                    errorFeedback={errors.coapplicantEmployerCity}
                  />
                </Col>
                <Col xs={12} sm={6} lg={4}>
                  <DropdownMenu
                    label="State"
                    name="coapplicantEmployerState"
                    options={usStates}
                    value={values.coapplicantEmployerState}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.coapplicantEmployerState && !errors.coapplicantEmployerState}
                    isInvalid={touched.coapplicantEmployerState && errors.coapplicantEmployerState}
                    errorFeedback={errors.coapplicantEmployerState}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={12} sm={6} lg={4}>
                  <InputBoxNumber
                    label="Zip"
                    name="coapplicantEmployerZipCode"
                    value={values.coapplicantEmployerZipCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    isValid={touched.coapplicantEmployerZipCode && !errors.coapplicantEmployerZipCode}
                    isInvalid={touched.coapplicantEmployerZipCode && errors.coapplicantEmployerZipCode}
                    errorFeedback={errors.coapplicantEmployerZipCode}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={4}>
                  <InputBoxPhone
                    label="Business Phone:"
                    name="coapplicantEmployerPhoneNumber"
                    value={values.coapplicantEmployerPhoneNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    isValid={touched.coapplicantEmployerPhoneNumber && !errors.coapplicantEmployerPhoneNumber}
                    isInvalid={touched.coapplicantEmployerPhoneNumber && errors.coapplicantEmployerPhoneNumber}
                    errorFeedback={errors.coapplicantEmployerPhoneNumber}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                  <p>Length of Time Employed</p>
                </Col>
              </Row>

              <Row>
                <Col xs={6} md={4}>
                  <InputBoxNumber
                    label="Years"
                    name="coapplicantEmployedYears"
                    value={values.coapplicantEmployedYears}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    isValid={touched.coapplicantEmployedYears && !errors.coapplicantEmployedYears}
                    isInvalid={touched.coapplicantEmployedYears && errors.coapplicantEmployedYears}
                    errorFeedback={errors.coapplicantEmployedYears}
                  />
                </Col>
                <Col xs={6} md={4}>
                  <InputBoxNumber
                    label="Months"
                    name="coapplicantEmployedMonths"
                    value={values.coapplicantEmployedMonths}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    isValid={touched.coapplicantEmployedMonths && !errors.coapplicantEmployedMonths}
                    isInvalid={touched.coapplicantEmployedMonths && errors.coapplicantEmployedMonths}
                    errorFeedback={errors.coapplicantEmployedMonths}
                  />
                </Col>
              </Row>
            </>
          ) : null}

          {shouldShowPreviousEmployment ? (
            <>
              <Row>
                <Col xs={12}>
                  <h3>Previous Employment Information</h3>
                  <p>
                    Previous employment is required if current employment or retirement time is less than two years.
                  </p>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <InputBox
                    label="Previous Employer Business Name"
                    name="coapplicantPreviousEmployerName"
                    value={values.coapplicantPreviousEmployerName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.coapplicantPreviousEmployerName && !errors.coapplicantPreviousEmployerName}
                    isInvalid={touched.coapplicantPreviousEmployerName && errors.coapplicantPreviousEmployerName}
                    errorFeedback={errors.coapplicantPreviousEmployerName}
                    length={100}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6}>
                  <InputBox
                    label="Occupation Title"
                    name="coapplicantPreviousOccupationTitle"
                    value={values.coapplicantPreviousOccupationTitle}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.coapplicantPreviousOccupationTitle && !errors.coapplicantPreviousOccupationTitle}
                    isInvalid={touched.coapplicantPreviousOccupationTitle && errors.coapplicantPreviousOccupationTitle}
                    errorFeedback={errors.coapplicantPreviousOccupationTitle}
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <InputBoxMoney
                    label="Gross Monthly Income:"
                    name="coapplicantPreviousGrossMonthlyIncome"
                    value={values.coapplicantPreviousGrossMonthlyIncome}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    isValid={
                      touched.coapplicantPreviousGrossMonthlyIncome && !errors.coapplicantPreviousGrossMonthlyIncome
                    }
                    isInvalid={
                      touched.coapplicantPreviousGrossMonthlyIncome && errors.coapplicantPreviousGrossMonthlyIncome
                    }
                    errorFeedback={errors.coapplicantPreviousGrossMonthlyIncome}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                  <p>Length of Time Employed</p>
                </Col>
              </Row>
              <Row>
                <Col xs={6} md={4}>
                  <InputBoxNumber
                    label="Years"
                    name="coapplicantPreviousEmployedYears"
                    value={values.coapplicantPreviousEmployedYears}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    isValid={touched.coapplicantPreviousEmployedYears && !errors.coapplicantPreviousEmployedYears}
                    isInvalid={touched.coapplicantPreviousEmployedYears && errors.coapplicantPreviousEmployedYears}
                    errorFeedback={errors.coapplicantPreviousEmployedYears}
                  />
                </Col>
                <Col xs={6} md={4}>
                  <InputBoxNumber
                    label="Months"
                    name="coapplicantPreviousEmployedMonths"
                    value={values.coapplicantPreviousEmployedMonths}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    isValid={touched.coapplicantPreviousEmployedMonths && !errors.coapplicantPreviousEmployedMonths}
                    isInvalid={touched.coapplicantPreviousEmployedMonths && errors.coapplicantPreviousEmployedMonths}
                    errorFeedback={errors.coapplicantPreviousEmployedMonths}
                  />
                </Col>
              </Row>
            </>
          ) : null}

          <Row>
            <Col xs={12}>
              <CheckBox
                label="If Additional Income, click here"
                name="coapplicantIsAdditionalIncome"
                // value={true}
                valueForm={values.coapplicantIsAdditionalIncome}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.coapplicantIsAdditionalIncome && !errors.coapplicantIsAdditionalIncome}
                isInvalid={touched.coapplicantIsAdditionalIncome && errors.coapplicantIsAdditionalIncome}
                errorFeedback={errors.coapplicantIsAdditionalIncome}
              />
            </Col>
          </Row>

          {values.coapplicantIsAdditionalIncome ? (
            <>
              <Row>
                <Col xs={12}>
                  <h3>Co-Buyer Additional Income</h3>
                </Col>
              </Row>

              <Row>
                <Col xs={12} md={6}>
                  <DropdownMenu
                    label="Additional Income Source"
                    name="coapplicantAdditionalIncomeSource"
                    options={additionalIncomeSources}
                    value={values.coapplicantAdditionalIncomeSource}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.coapplicantAdditionalIncomeSource && !errors.coapplicantAdditionalIncomeSource}
                    isInvalid={touched.coapplicantAdditionalIncomeSource && errors.coapplicantAdditionalIncomeSource}
                    errorFeedback={errors.coapplicantAdditionalIncomeSource}
                  />
                </Col>
                {values.coapplicantAdditionalIncomeSource.toLowerCase() === 'other' ? (
                  <Col xs={12} md={6}>
                    <InputBox
                      label="Other"
                      name="coapplicantAdditionalIncomeSourceOther"
                      value={values.coapplicantAdditionalIncomeSourceOther}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isValid={
                        touched.coapplicantAdditionalIncomeSourceOther && !errors.coapplicantAdditionalIncomeSourceOther
                      }
                      isInvalid={
                        touched.coapplicantAdditionalIncomeSourceOther && errors.coapplicantAdditionalIncomeSourceOther
                      }
                      errorFeedback={errors.coapplicantAdditionalIncomeSourceOther}
                    />
                  </Col>
                ) : null}
                <Col xs={12} md={6}>
                  <InputBoxMoney
                    label="Monthly Income:"
                    name="coapplicantAdditionalMonthlyIncome"
                    value={values.coapplicantAdditionalMonthlyIncome}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    isValid={touched.coapplicantAdditionalMonthlyIncome && !errors.coapplicantAdditionalMonthlyIncome}
                    isInvalid={touched.coapplicantAdditionalMonthlyIncome && errors.coapplicantAdditionalMonthlyIncome}
                    errorFeedback={errors.coapplicantAdditionalMonthlyIncome}
                  />
                </Col>
              </Row>
            </>
          ) : null}
        </div>
      ) : null}
    </>
  );
};
